<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="Basic Mashing Tools">
<div class="titlepage">
<div>
<div>
<h1 class="title"><a id="d0e120" xmlns:saxon="http://icl.com/saxon">Basic Mashing Tools
            </a></h1><a id="d0e120" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e120" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e120" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e120" xmlns:saxon="http://icl.com/saxon">
</a><p><a id="d0e120" xmlns:saxon="http://icl.com/saxon"></a><a id="bmasht" xmlns:saxon="http://icl.com/saxon"><span class="subhead">Manual
          Masher</span> This is the stalwart of the mashed kitchen and can be used to mash almost
        anything, as long as it’s got a little elbow grease behind it. Most come in one of two
        varieties, with a mash element that looks more like a grid or with a mash element that looks
        more like the coils on a furnace. I own the former, and find it works very well. Manual
        mashers work best with soft, pliable cooked vegetables or fruits and yield a more rustic
        effect, as in the </a><a class="link" href="#/ch04#masterrv" id="d0e127" title="Ultimate Mashed Potatoes Master Recipe—Rustic Version">Ultimate Mashed Potatoes
          Master Recipe—Rustic Version</a>. To use it, just push down and through what you’re
        working with, swirling a little to bring stray bits back into the bowl and into the mash
        fold. </p>
<p><span class="subhead">Food Mill</span> Another old-school manual-masher method, it remains
        one of the best, particularly for foods you want to cook with the skin on (such as tomatoes,
        apples, pears, or potatoes) for flavor and nutrition reasons, but ultimately want the skins
        removed in the mashing process. Food mills come with many different-size holes (also known
        as rice) and operate by turning the handle around the mill, going backward from time to time
        to further press the contents. The mill will hold the skins, but release the milled food
        through the bottom. Using one sets the stage for some of the fluffiest, most elegant mashed
        potatoes and applesauces imaginable. </p>
<p><span class="subhead">Food Processor</span> For the purposes of mashing, I almost always
        use mine fitted with a metal blade. A food processor is extra well-suited to puréeing more
        dense foods (like Brussels sprouts or celery root) or getting a very silky, smooth purée on
        roasted vegetables and some soups. </p>
<p><span class="subhead">Electric Blender</span> Though I use this less throughout the book,
        it’s ideal for blending creams into compotes (such as the milk shake) or any time you want
        to build extra froth into your mash. It’s not very well-suited to recipes containing a large
        ratio of hot liquid to solid, cooked matter. The liquid will often seep from the bottom. </p>
<p><span class="subhead">Immersion Blenders</span> The best friend of a lazy dishwasher and a
        sensible cook, these mash-friendly tools are named after their function. They are immersed
        into whatever they’re going to mash, most often into a soup pot to purée the ingredients as
        much or as little as you like. A quick whir (as I call it), will break up the threads of
        tougher greens (such as collards), yielding a kind of mini mash, while a full-on purée will
        completely emulsify most foods. Sometimes larger or harder chunks of food need a little
        nudge to get started. I do this by running the blender, pressing directly down onto the
        harder pieces, and ultimately integrating the entire pot into a purée. Not only do they save
        washing additional pots, but they’re also extremely easy to wash themselves, usually
        requiring only a little swish through hot, soapy water. </p>
<p><span class="subhead">Hand-Held Electric Mixer</span> For the purposes of recipes in <span class="emphasis">
<em>Mashed</em>
</span>, this was used exclusively for mounting egg whites and whipped cream. A whisk can do
        the same thing, but it’s a bit more work.</p>
<div class="mediaobject" title="Photo of mashing tool with a stack of bowls.">
<img alt="Photo of mashing tool with a stack of bowls." src="images/Outtake_1--991.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch02.vue?36b0e272